import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.statistics__card' ).not( '.is-animated' ).each( function( key, component ) {
        let isAnimated = false;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 95%',
            scrub: 0.5,
            onEnter: ( {progress, direction, isActive} ) => {
              if ( !isAnimated ) {
                numberAnimations( component );
                isAnimated = true;
              }
            },
          },
        } );
      } );

      function numberAnimations( el ) {
        $( el ).find( 'text.increase-num' ).each( function() {
          const $this = $( this );
          const finalVal = parseFloat( $this.data( 'number' ) );
          const suffix = $this.data( 'suffix' ) || '';
          const decimals = ( finalVal.toString().split( '.' )[1] || '' ).length;

          $( {Counter: 0} ).animate(
              {Counter: finalVal},
              {
                duration: 1000,
                easing: 'swing',
                step: function() {
                  const value = this.Counter
                      .toFixed( decimals )
                      .replace( /\B(?=(\d{3})+(?!\d))/g, ',' );

                  $this.text( value + suffix );
                },
                complete: function() {
                  const finalFormatted = finalVal
                      .toFixed( decimals )
                      .replace( /\B(?=(\d{3})+(?!\d))/g, ',' );

                  $this.text( finalFormatted + suffix );
                },
              },
          );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'statistics', COMPONENT );
} )( app );
